var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.215,
    height: 77.532,
    viewBox: "0 0 91.215 77.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,10H52.03L47.469,28.243l4.561,15.05L46.557,53.327l15.05,13.682-11.4,10.034,15.963,5.929-4.561,4.561H16Z",
    fill: "#504c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.873,10,262.4,28.243l2.736,15.506L262.4,53.327l12.314,14.138-9.121,9.121,15.05,5.929-5.473,5.017h38.31V10Z",
    transform: "translate(-206.266)",
    fill: "#504c4c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.306a076c90348f407be5b84c67f2f59d.svg";
export { ForwardRef as ReactComponent };